import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "reduxStore/action/authActions";
import { emailAddressValid, seo } from "utils/utils";
import AuthShell from "../AuthShell";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [forgotDetail, setForgotDetail] = useState({});
  const [errorMessage, setErrorMessage] = useState({});

  const dispatch = useDispatch();
  const forgotPasswordSelector =
    useSelector((state) => state.forgotPassword) || {};

  const forgotUser = async () => {
    const { response, otpSend = false } = forgotPasswordSelector || {};
    if (response && otpSend) {
      if (response?.status === 200) {
        navigate("/verifyotp");
      }
    }
  };

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      sendOtp();
    }
  };

  useEffect(() => {
    forgotUser();
  }, [forgotPasswordSelector]);

  const validation = () => {
    let isError = true;
    let nextErrors = {};

    if (forgotDetail.email == undefined || forgotDetail.email === "") {
      isError = false;
      nextErrors.email = strings.emailRequire;
    } else if (!emailAddressValid(forgotDetail.email)) {
      isError = false;
      nextErrors.email = strings.emailValidationErr;
    }

    setErrorMessage(nextErrors);
    return isError;
  };

  const sendOtp = () => {
    if (validation()) {
      dispatch(forgotPassword(forgotDetail));
    }
  };

  useEffect(() => {
    seo({
      title: "Forgot Password",
      metaDescription: "Forgot password",
      canonicalLink: window.location.href,
    });
  }, []);

  const canSubmit = Boolean(forgotDetail.email?.trim());

  return (
    <Fragment>
      <AuthShell
        title={strings.forgotpass}
        subtitle={strings.enterEmailForResetPass}
      >
        <form
          className="justo-login__form"
          onSubmit={(e) => {
            e.preventDefault();
            sendOtp();
          }}
        >
          <div className="justo-login__field">
            <label className="justo-login__label" htmlFor="forgot_email">
              {strings.yourEmail}
              <span className="justo-login__required" aria-hidden="true">
                *
              </span>
            </label>
            <input
              className="form-control justo-login__input"
              id="forgot_email"
              type="email"
              autoComplete="email"
              placeholder={strings.emailPlaceholder}
              value={forgotDetail.email || ""}
              onChange={(e) =>
                setForgotDetail({
                  ...forgotDetail,
                  email: e.target.value,
                })
              }
              onKeyDown={handleEnterPress}
            />
            {errorMessage.email ? (
              <span className="justo-login__error">{errorMessage.email}</span>
            ) : null}
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block justo-login__submit"
            disabled={!canSubmit}
          >
            {strings.sendOTP}
          </button>
        </form>
      </AuthShell>
    </Fragment>
  );
};

export default ForgotPassword;
